import ModalBase from "../modals/ModalBase";
import { describeRestorePoint, scopeLabel } from "../../js/accounts/restorePoints";

export default function RestoreConfirmModal({ point, isOpen, onClose, onConfirm, busy = false }) {
  if (!point) return null;
  const scope = scopeLabel(point.scope);
  return (
    <ModalBase isOpen={isOpen} title="Confirm restore" onClose={onClose} compact quiet>
      <p>You are about to restore:</p>
      <p>
        <strong>{point.label || "Snapshot"}</strong>
      </p>
      <p className="muted">{describeRestorePoint(point)}</p>
      <p className="restore-confirm-warn">
        Current {scope.toLowerCase()} data on this device will be replaced. A safety snapshot is taken first.
      </p>
      <label className="field-label" htmlFor="restore-confirm-input">
        Type <strong>RESTORE</strong> to confirm
      </label>
      <form
        className="restore-confirm-form"
        onSubmit={(event) => {
          event.preventDefault();
          const input = event.currentTarget.elements.namedItem("confirmText");
          if (input?.value?.trim().toUpperCase() !== "RESTORE") return;
          onConfirm(point);
        }}
      >
        <input id="restore-confirm-input" className="field-input" name="confirmText" autoComplete="off" required />
        <div className="btn-row">
          <button type="submit" className="primary-btn" disabled={busy}>
            {busy ? "Restoring…" : "Restore this point"}
          </button>
          <button type="button" className="ghost-btn" onClick={onClose} disabled={busy}>
            Cancel
          </button>
        </div>
      </form>
    </ModalBase>
  );
}
